const getDiagnosticData = (args) => {
    const getDiagnosticParameters = (args) => {
        let tags = [];
        let diagnostics = {};

        if (args.verMO) {
            args.chat_profile && tags.push(args.chat_profile);

            const getDiagnosticsForMO = (args) => {
                const attributesToRemove = [
                    'verMO',
                    'contactProcessType',
                    'loginType',
                    'email',
                    'customerType',
                    'code'
                ];
                const diagnostics = Object.assign({}, args);
                attributesToRemove.forEach((a) => {
                    if (diagnostics[a]) {
                        delete diagnostics[a];
                    }
                });
                return diagnostics;
            };

            diagnostics = getDiagnosticsForMO(args);
        } else {
            tags = args.tags || [];
            diagnostics = args.diagnostics;
        }

        tags.push('bot');
        tags.push('diagnostic');

        return [tags, diagnostics];
    };

    let [tags, diagnostics] = getDiagnosticParameters(args);

    const serializeDiagnosticToString = (diagnostics) => {
        const serialized = [];
        for (const property in diagnostics) {
            serialized.push(`${property}:${diagnostics[property] ? diagnostics[property] : '-'}`);
        }
        return serialized.join(', ');
    };

    const now = new Date(Date.now());
    const nowString = now.toLocaleDateString('pl') + ', ' + now.toLocaleTimeString('pl');

    return {
        tags: tags,
        additionalData: {
            ...(diagnostics && {
                diagnostics: serializeDiagnosticToString(diagnostics),
                'diagnostic date': nowString
            })
        }
    };
};

export default getDiagnosticData;
